module.exports = __webpack_public_path__ + "img/sem_pena.5db7c44d.jpg";